module.exports = __webpack_public_path__ + "media/images/logo-footer-8434a3e66e727f99fba39c76de079875.png";